<div class="execution-cycle-card">
  <!-- Header: Checkbox + Name + Badge + Status -->
  <div class="card-header">
    <div class="header-left">
      <input 
        *ngIf="showCheckbox"
        type="checkbox" 
        class="cycle-checkbox" 
        [checked]="isChecked"
        (change)="onCheckboxChange($event)" />
      
      <span class="cycle-name">{{ cycle.name }}</span>
      
      <span *ngIf="badge" class="cycle-badge">{{ badge }}</span>
    </div>
    
    <div class="header-right">
      <app-status-badge [status]="cycle.status" [size]="'medium'"></app-status-badge>
    </div>
  </div>

  <!-- Content: Timeline + Progress -->
  <div class="card-content">
    <!-- Execution Timeline -->
    <div class="timeline-section">
      <h4 class="section-title">Execution Timeline</h4>
      <div class="timeline-grid">
        <div class="timeline-item">
          <span class="timeline-label">Start Time</span>
          <span class="timeline-value">{{ formatDate(cycle.startTime) }}</span>
        </div>
        <div class="timeline-item">
          <span class="timeline-label">End Time</span>
          <span class="timeline-value">{{ formatDate(cycle.endTime) }}</span>
        </div>
        <div class="timeline-item duration-row">
          <span class="timeline-label">Duration</span>
          <span class="timeline-value">{{ calculateDuration() }}</span>
        </div>
      </div>
    </div>

    <!-- Overall Progress -->
    <div class="progress-section">
      <div class="progress-header">
        <h4 class="section-title">Overall Progress</h4>
        <span class="completion-text">{{ completedLabel }}</span>
      </div>
      
      <app-multi-segment-progress-bar
        [counts]="{
          passed: cycle.passedCount,
          failed: cycle.failedCount,
          executing: cycle.executingCount,
          waiting: cycle.waitingCount
        }"
        [total]="cycle.totalCount"
        [barHeight]="20"
        [borderRadius]="50">
      </app-multi-segment-progress-bar>
    </div>
  </div>

  <!-- Footer: View Details Link -->
  <div class="card-footer">
    <a class="view-details-link" (click)="onViewDetails()">
      View Details
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </a>
  </div>
</div>
